import { CardStackSocket } from "../../types/types";
import { CardStack } from "./CardStack";



export class TableStackPlay extends CardStack
{

    private defaultSocket: CardStackSocket = { posX: 0, posY: 0, angle: 0 };
    // template 
    // each player gets its socket with variable deviation from defaults (pos, rotation)
    // each trick get multiple player sockets to random from
    // format: cardStackSocketTemplates[trickSocketsIndex][playerIndex]
    private cardStackSocketTemplates: CardStackSocket[][] = [
        [
            // player top
            { posX: 0, posY: -110, angle: -20 },
            // player right
            { posX: 110, posY: -20, angle: 25 },
            // player bot
            { posX: -10, posY: 110, angle: -30 },
            // player left
            { posX: -120, posY: -20, angle: 35 },
        ],
        [
            // player top
            { posX: 0, posY: -110, angle: 20 },
            // player right
            { posX: 100, posY: 50, angle: -25 },
            // player bot
            { posX: 0, posY: 110, angle: 5 },
            // player left
            { posX: -120, posY: 40, angle: -30 },
        ],
        [
            // player top
            { posX: 60, posY: -110, angle: -40 },
            // player right
            { posX: 120, posY: 40, angle: -15 },
            // player bot
            { posX: -20, posY: 110, angle: 35 },
            // player left
            { posX: -120, posY: 0, angle: 10 },
        ],
        [
            // player top
            { posX: 10, posY: -110, angle: 20 },
            // player right
            { posX: 120, posY: 40, angle: 15 },
            // player bot
            { posX: 0, posY: 110, angle: -25 },
            // player left
            { posX: -120, posY: 0, angle: -10 },
        ],
        [
            // player top
            { posX: 0, posY: -110, angle: -20 },
            // player right
            { posX: 120, posY: 40, angle: 15 },
            // player bot
            { posX: -30, posY: 110, angle: 25 },
            // player left
            { posX: -110, posY: 20, angle: 10 },
        ],
        [
            // player top
            { posX: 0, posY: -110, angle: 10 },
            // player right
            { posX: 120, posY: -30, angle: 15 },
            // player bot
            { posX: 40, posY: 110, angle: 30 },
            // player left
            { posX: -120, posY: -30, angle: -10 },
        ],

        // DEBUG CENTERED STACK
        // NOTE: also uncomment 'return' inside StackCollector#start
        // [
        //     // player top
        //     { posX: 0, posY: -120, angle: 0 },
        //     // player right
        //     { posX: 120, posY: 0, angle: 0 },
        //     // player bot
        //     { posX: 0, posY: 120, angle: 0 },
        //     // player left
        //     { posX: -120, posY: 0, angle: 0 },
        // ],
    ];
    private curSocketsIndex: number = Math.floor(Math.random() * this.cardStackSocketTemplates.length);

    public Init(): void { }

    public GetSocket(playerIndex: number): CardStackSocket
    {
        const socketData: CardStackSocket = this.cardStackSocketTemplates[this.curSocketsIndex][playerIndex];
        return socketData ?? this.defaultSocket;
    }

    /**
     * @see TrickCollector#Start
     */
    public override NextSocketsIndex(): void
    {
        this.curSocketsIndex = (this.curSocketsIndex + 1) % this.cardStackSocketTemplates.length;
    }
}